export class Router {
  public routerId: string;
  readonly regularMonthlyCharge: number;
  readonly campaignMonthlyCharge: number;

  constructor(routerId: string, 月額特典料金: number, 月額標準料金: number) {
    this.routerId = routerId;
    this.regularMonthlyCharge = 月額標準料金;
    this.campaignMonthlyCharge = 月額特典料金;
  }

  public monthlyCharge(): number {
    return this.regularMonthlyCharge + this.campaignMonthlyCharge;
  }
}
